// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1Dg8T","footer":"ModalInfo_footer__2RdnM"};